module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID:
      "551863272940-tk6v8vmt0hhnpjpvljbvn1tuhv97k3jh.apps.googleusercontent.com",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
};
